import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

import config from '@/config';

const { APP_DOMAIN: domain } = config;

const getUser = () => {
  const accessToken = getAccessToken();
  if (!accessToken) return null;
  const decodedToken = jwtDecode<{ user?: { id: number } }>(accessToken);
  return decodedToken.user;
};

export const getAccessToken = () => Cookies.get('access_token');

export const getRefreshToken = () => Cookies.get('refresh_token');

export const removeAccessToken = () =>
  Cookies.remove('access_token', { domain });

export const removeRefreshToken = () =>
  Cookies.remove('refresh_token', { domain });

export const setAccessToken = (accessToken: string) =>
  Cookies.set('access_token', accessToken, {
    domain,
    expires: 365,
  });

export const setRefreshToken = (refreshToken: string) =>
  Cookies.set('refresh_token', refreshToken, {
    domain,
    expires: 365,
  });

export const getAccessTokenUserId = () => {
  const user = getUser();
  return user?.id;
};

export const setUtmParametersCookie = (utmParams: string) => {
  Cookies.set('utm_params', utmParams, {
    domain,
    expires: 30,
  });
};

export const getUtmParametersCookie = () => {
  const utmParams = Cookies.get('utm_params');
  return utmParams;
};

export const getClientId = () => {
  return Cookies.get('_ga')?.substring(6);
};

export const removeUtmParametersCookie = () => {
  Cookies.remove('utm_params', { domain });
};

export const getSignupPrefillCookie = () => {
  const signupPrefill = Cookies.get('signup_prefill');
  return signupPrefill;
};

export const removeSignupPrefillCookie = () => {
  Cookies.remove('signup_prefill', { domain });
};

export const getAdAttributionCookies = () => {
  const cookies = document.cookie.split('; ');
  return cookies
    .filter(
      cookie =>
        cookie.startsWith('_ga') || // Google Analytics
        cookie.startsWith('_gcl_') || // Google Ads - 90 days
        cookie.startsWith('FPAU') || // Google Ads - 90 days
        cookie.startsWith('FPGSID') || // Google Ads - 90 days
        cookie.startsWith('FPLC') || // Google Ads - 90 days
        cookie.startsWith('_uet') || // Microsoft Ads - ~90 days
        cookie.startsWith('_cl') || // Microsoft Ads - ~90 days
        cookie.startsWith('MUID') || // Microsoft Ads - ~90 days
        cookie.startsWith('ANID') || // Microsoft Ads - ~90 days
        cookie.startsWith('ANONCHK') || // Microsoft Ads - ~90 days
        cookie.startsWith('li_') || // LinkedIn Ads - 30 days
        cookie.startsWith('_fb') || // Meta (browser ID) -	~90 days
        cookie.startsWith('__oppref') || // OpenAI Ads - 30 days
        cookie.startsWith('__oaiq_domain_probe') || // OpenAI Ads - 30 days
        cookie.startsWith('_ttp') || // TikTok
        cookie.startsWith('twclid') || // Twitter
        cookie.startsWith('rdt_cid'), // Reddit Ads
    )
    .reduce(
      (acc, cookie) => {
        const [key, value] = cookie.split('=');
        acc[decodeURIComponent(key)] = decodeURIComponent(value);
        return acc;
      },
      {} as Record<string, string>,
    );
};
